import { render, staticRenderFns } from "./Index-utk.vue?vue&type=template&id=0a96c444&scoped=true"
import script from "./Index-utk.vue?vue&type=script&lang=js"
export * from "./Index-utk.vue?vue&type=script&lang=js"
import style0 from "./Index-utk.vue?vue&type=style&index=0&id=0a96c444&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a96c444",
  null
  
)

export default component.exports